import updateApolloList from './updateApolloList';
import type { DataKeysForFetchResult, PathsToArrayValues } from './typeUtils';

export default function updateSubscribedList<
  TData extends object,
  TSubscriptionData,
>(
  listPath: PathsToArrayValues<TData>,
  itemKey: DataKeysForFetchResult<TSubscriptionData>,
  add?: boolean,
) {
  return (
    prev: TData,
    {
      subscriptionData: { data },
    }: { subscriptionData: { data: TSubscriptionData } },
  ) => {
    return updateApolloList(prev, data, listPath, itemKey, add);
  };
}
